import React from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastProvider } from './components/GlobalToast';
import ProtectedRoute from './components/ProtectedRoute';
 
import FileUploadHubspot from "./components/FileUploadHubspot";
import DisputeResolution from "./components/DisputeResolution";
import Thankyou from "./components/Thankyou";
import Login from "./components/Login";
import SecurePortal from './components/SecurePortal';
import TicketEntry from "./components/TicketEntry";
import MerchantConsentThankYou from "./components/MerchantConsentThankYou";
import Logout from './components/Logout';
import NotFound from './components/NotFound';
import ResetPasswordPage from './components/ResetPasswordPage';
import UploadFailed from "./components/UploadFailed";
import '@fortawesome/fontawesome-free/css/all.min.css';
 
import "./App.css";
 
function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          {/* Default: Dispute Resolution */}
          <Route path="/dispute" element={<DisputeResolution />} />
          {/* <Route path="/dispute/:ticketId" element={<DisputeResolution />} /> */}
          <Route path="/upload" element={<FileUploadHubspot />} />
          {/* <Route path="/upload/:ticketId" element={<FileUploadHubspot />} /> */}
          <Route path="/thankyou" element={<Thankyou />} />
          <Route path="/secure-portal" element={<ProtectedRoute><SecurePortal /></ProtectedRoute>} />
          <Route path="/ticket-entry" element={<TicketEntry />} />
          <Route path="/merchant-consent-thankyou" element={<MerchantConsentThankYou />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/failed" element={<UploadFailed />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}
  
  export default App;
